<script>
import BaseReportManager from '../base-report/BaseReportManager.vue'

export default class InvoiceReceivedCompetenceReport extends BaseReportManager {
}
</script>
